<template>
  <div class="period_setting" :key="$i18n.locale">
    <flat-pickr v-model="dateRange" :config="config" @on-change="updateDate" />
    <custom-selectbox
      :class="['month_select', $i18n.locale, monthSelected === -1 ? 'initial' : '']"
      v-model="monthSelected"
      :items="monthArr"
      :firstItem="$t('date.selectMonth')"
      @custom-select="handleMonth"
    />
    <custom-selectbox :value="pointListStatus" :items="cateArr" @custom-select="handleCate" />
    <v-button
      class="btn05"
      @handleClick="handleClick"
      iconClass="icon_search"
      :text="$t('common.btnSearch')"
    ></v-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VButton from '@/components/atoms/VButton';
import CustomSelectbox from '@/components/atoms/CustomSelectbox';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import { english } from 'flatpickr/dist/l10n/default.js';
import { MandarinTraditional } from 'flatpickr/dist/l10n/zh-tw.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import { MONTH_NAME_LIST } from '@/consts/consts';

export default {
  components: {
    flatPickr,
    VButton,
    CustomSelectbox,
  },
  props: {
    cateArr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      now: '',
      dateRange: '',
      config: {
        static: true,
        altFormat: 'Y-m-d',
        altInput: true,
        dateFormat: 'Y-m-d',
        mode: 'range',
        locale: this.dateLocale || english,
        monthSelectorType: 'static',
        maxDate: this.$moment().format('YYYY-MM-DD'),
      },
      monthSelected: -1,
      monthArr: [],
    };
  },
  watch: {
    '$i18n.locale': function () {
      this.setDateLocale();
    },
  },
  computed: {
    ...mapGetters('point', [
      'pointListPageSize',
      'pointListPageNo',
      'pointListStartDate',
      'pointListEndDate',
      'pointListStatus',
    ]),
    dateLocale() {
      switch (this.$i18n.locale) {
        case 'ko':
          return Korean;
        case 'en':
          return english;
        case 'zh':
          return MandarinTraditional;
        case 'ja':
          return Japanese;
        default:
          return english;
      }
    },
    dateMiddleText() {
      return this.$i18n.t('date.middle');
    },
  },
  mounted() {
    this.setDateLocale();
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('point', [
      'getPointHistory',
      'setPointListPageNo',
      'setPointListStartDate',
      'setPointListEndDate',
      'setPointListStatus',
    ]),
    setDateLocale() {
      this.config.locale = this.dateLocale;
      this.now = this.$moment();
      this.dateRange = this.pointListStartDate + this.dateMiddleText + this.pointListEndDate;
      this.setMonthArr();
    },
    updateDate(selectedDates) {
      if (selectedDates.length === 2) {
        this.setPointListStartDate(this.$moment(selectedDates[0]).format('YYYY-MM-DD'));
        this.setPointListEndDate(this.$moment(selectedDates[1]).format('YYYY-MM-DD'));
      }
    },
    handleMonth() {
      if (this.monthSelected === -1) return;
      let startDate = '';
      let endDate = '';
      const middleText = this.dateMiddleText;
      startDate = this.$moment().subtract(this.monthSelected, 'months').startOf('month').format('YYYY-MM-DD');

      if (this.monthSelected === 0) {
        endDate = this.now.format('YYYY-MM-DD');
      } else {
        endDate = this.$moment().subtract(this.monthSelected, 'months').endOf('month').format('YYYY-MM-DD');
      }
      this.dateRange = startDate + middleText + endDate;
    },
    handleCate(val) {
      this.setPointListStatus(val);
    },
    async handleClick() {
      if (this.checkTerm()) {
        this.setPointListPageNo(1);
        await this.getPointHistory({
          startDate: this.pointListStartDate,
          endDate: this.pointListEndDate,
          pointStatus: this.pointListStatus,
          pageNo: this.pointListPageNo,
          pageSize: this.pointListPageSize,
        });
      } else {
        this.openModal({
          type: 'alert',
          message: this.$i18n.t('error.search.day'),
        });
      }
    },
    setMonthArr() {
      this.monthArr = [];
      let year = Number(this.now.format('YYYY')),
        month = Number(this.now.format('M'));
      for (let i = 0; i <= 12; i++) {
        if (this.$i18n.locale === 'ko' || this.$i18n.locale === 'zh' || this.$i18n.locale === 'ja') {
          this.monthArr.push(`${year}${this.$i18n.t('date.year')} ${month}${this.$i18n.t('date.month')}`);
        } else if (this.$i18n.locale === 'en') {
          this.monthArr.push(`${MONTH_NAME_LIST[month - 1]}, ${year}`);
        }

        month--;
        if (month <= 0) {
          year--;
          month = 12;
        }
      }
    },
    checkTerm() {
      return this.$moment(this.pointListEndDate).diff(this.$moment(this.pointListStartDate), 'days') <= 31;
    },
  },
};
</script>

<style lang="scss">
@media screen and (min-width: 767px) {
  .period_setting {
    .month_select.en.initial {
      .selectbox {
        font-size: 13px;
      }
    }
  }
}
</style>
